class EofyRewards extends HTMLElement {
  connectedCallback() {
    if (this.dataset.eofyRewardsInit === 'true') return;
    this.dataset.eofyRewardsInit = 'true';

    this.initInfoTooltips();
    this.initModuleImpression();
    this.querySelectorAll(".eofy-rewards__button,.eofy-rewards__gift-banner-button").forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector(".eofy-tier__inner").scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
    if (this.moduleImpressionObserver) {
      this.moduleImpressionObserver.disconnect();
      this.moduleImpressionObserver = null;
    }
  }

  initInfoTooltips() {
    this.triggers = this.querySelectorAll('.eofy-rewards__info-trigger');
    if (!this.triggers.length) return;

    this.onDocumentClick = this.handleDocumentClick.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleTooltip(trigger);
      });
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  isInView() {
    const rect = this.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    return visible >= rect.height * 0.33;
  }

  pushModuleImpressionGa4() {
    if (this.dataset.eofyRewardsModuleImpression === 'true') return;
    this.dataset.eofyRewardsModuleImpression = 'true';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'module_impression',
      event_parameters: {
        module: 'benefits',
      },
    });
  }

  tryPushModuleImpressionGa4() {
    if (this.dataset.eofyRewardsModuleImpression === 'true') return false;
    if (!this.isInView()) return false;
    this.pushModuleImpressionGa4();
    return true;
  }

  initModuleImpression() {
    if (!('IntersectionObserver' in window)) {
      this.tryPushModuleImpressionGa4();
      return;
    }

    this.moduleImpressionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (this.tryPushModuleImpressionGa4()) {
            this.moduleImpressionObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.33 }
    );

    this.moduleImpressionObserver.observe(this);
    this.tryPushModuleImpressionGa4();
  }

  toggleTooltip(trigger) {
    const tooltipId = trigger.getAttribute('aria-controls');
    const tooltip = tooltipId ? document.getElementById(tooltipId) : null;
    if (!tooltip) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    this.closeAllTooltips();

    if (!isOpen) {
      trigger.setAttribute('aria-expanded', 'true');
      tooltip.hidden = false;
    }
  }

  closeAllTooltips() {
    if (!this.triggers) return;
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
      const tooltipId = trigger.getAttribute('aria-controls');
      const tooltip = tooltipId ? document.getElementById(tooltipId) : null;
      if (tooltip) tooltip.hidden = true;
    });
  }

  handleDocumentClick(event) {
    if (event.target.closest('.eofy-rewards__info-wrap')) return;
    this.closeAllTooltips();
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.closeAllTooltips();
  }
}

if (!customElements.get('eofy-rewards')) {
  customElements.define('eofy-rewards', EofyRewards);
}
